import { useLocation } from 'react-router-dom';

export const useSearchParams = (
  key: string,
  pattern?: string[],
): string | null => {
  const search = new URLSearchParams(useLocation().search);
  const value = search.get(key);

  if (!pattern) {
    return value;
  }

  if (value && pattern.includes(value)) {
    return value;
  }

  return null;
};
